import React, { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import cx from 'classnames'
import { nowDateMinusOneMonth, nowDatePlusOneDay } from 'pages/currentawareness/Util'
import { AnnouncementsSkeleton, StoriesSkeleton } from 'pages/dashboard/Skeleton'
import HomePageContentPanels from 'pages/dashboard/HomePageContentPanels'
import AnnouncementsHeader from 'pages/dashboard/AnnouncementsHeader'
import selectCmsCtx from 'redux/selectors/selectCmsCtx'
import selectPlaceholders from 'redux/selectors/selectPlaceholders'
import StoriesWrapperContainer from 'redux/containers/pages/dashboard/StoriesWrapperContainer'
import { CaThemeProvider } from 'components/redesign/CaThemeProvider'

const Stories = ({ aol }) => {
  const { isHomePageStoriesLoaded } = useSelector(selectPlaceholders)
  const fromDate = nowDateMinusOneMonth()
  const toDate = nowDatePlusOneDay()

  return (
    <div className='bt-thick bt--dark-cerulean'>
      {!isHomePageStoriesLoaded && <StoriesSkeleton />}
      <div className={cx({ dn: !isHomePageStoriesLoaded })}>
        <StoriesWrapperContainer {...{ fromDate, toDate, aol }} />
      </div>
    </div>
  )
}

const GridLayout = ({ isLogged, setDashboardIsLoaded, cmsCtx, aol }) => {
  useLayoutEffect(() => {
    setDashboardIsLoaded(!!cmsCtx)
  }, [setDashboardIsLoaded, cmsCtx])

  return (
    <div className='bg-page-background'>
      {/* Header is now handled by DashboardHeader via controller */}
      <div className={cx('layout-width-constraint bg-page-background', { 'pt0 pb8': isLogged, pv0: !isLogged })}>
        <CaThemeProvider>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={9}>
              <Stories aol={aol} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3}>
              <ContentPanelsWrapper aol={aol} />
            </Grid>
          </Grid>
        </CaThemeProvider>
      </div>
    </div>
  )
}

const ContentPanelsWrapper = ({ aol }) => {
  const { isHomepageFcUpdatesLoaded } = useSelector(selectPlaceholders)
  const cmsCtx = useSelector(selectCmsCtx)

  return (
    <div className='bg-page-background'>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <AnnouncementsHeader />
      </Box>
      {!isHomepageFcUpdatesLoaded && (
        <>
          <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
            <AnnouncementsSkeleton maxHeight={1712} />
          </Box>
          <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
            <AnnouncementsSkeleton maxHeight={595} />
          </Box>
        </>
      )}
      <div className={cx({ dn: !isHomepageFcUpdatesLoaded })}>
        {cmsCtx && aol && <HomePageContentPanels cmsCtx={cmsCtx} aol={aol} />}
      </div>
    </div>
  )
}

export default GridLayout
